import styled from 'styled-components';

export const FormLabel = styled.label`
  display: block;
  color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
  font-weight: 700;
  font-size: 16px;
  line-height: 21px;
  margin-bottom: 8px;
`;
